import clsx from 'clsx';
import styles from './divider.module.scss';

interface DividerProps {
  dividerType?: string;
  customClass?: string;
}
export const DIVIDER_TYPES = {
  standard: 'standard',
  heavy: 'heavy',
};
export const getDividerStyle = (dividerType: string | undefined)=>{
  return dividerType === DIVIDER_TYPES.standard ? styles.standard : styles.heavy
}
export const Divider = ({ dividerType, customClass }: DividerProps) => {
  let dividerClass = getDividerStyle(dividerType);

  return (
    <hr
      className={clsx(dividerClass, customClass)}
      data-testid="root-divider"
    />
  );
};
